import { useFormik } from 'formik'
import ModalComponent from '..'
import {
  useApproveRefundMutation,
  useDeclineRefundMutation,
} from '../../../redux-toolkits/transactions/transactions.slice'
import {
  ApproveRefundSchema,
  DeclineRefundSchema,
} from '../../../validation/validate'
import { Button } from '../../button'
import { TextInput } from '../../inputs/textInput'

export const ConfirmRefundActionModal = ({
  open,
  setOpen,
  onCloseCallback,
  onSuccessCallback,
  refundId,
  actionType = 'approve',
}: {
  open: boolean
  setOpen: (val: boolean) => void
  onCloseCallback?: () => void
  onSuccessCallback?: () => void
  refundId: string
  actionType: 'approve' | 'reject'
}) => {
  const [approveRefund, { isLoading: approvingRefund }] =
    useApproveRefundMutation()

  const [declineRefund, { isLoading: decliningRefund }] =
    useDeclineRefundMutation()

  const { values, errors, handleChange, handleBlur, handleSubmit, touched } =
    useFormik({
      initialValues: {
        password: '',
        reason: '',
      },
      validationSchema:
        actionType === 'approve' ? ApproveRefundSchema : DeclineRefundSchema,
      onSubmit: async (values) => {
        if (actionType === 'approve') {
          const response = await approveRefund({
            id: refundId,
            password: values.password,
          })

          if (response.data?.success) {
            setOpen(false)
            if (onCloseCallback) {
              onCloseCallback()
            }
            if (onSuccessCallback) {
              onSuccessCallback()
            }
          }
        } else {
          const response = await declineRefund({
            id: refundId,
            reason: values.reason,
          })

          if (response.data?.success) {
            setOpen(false)
            if (onCloseCallback) {
              onCloseCallback()
            }
            if (onSuccessCallback) {
              onSuccessCallback()
            }
          }
        }
      },
    })

  return (
    <ModalComponent
      open={open}
      setOpen={setOpen}
      onCloseCallback={onCloseCallback}
      title={
        actionType === 'approve'
          ? 'Enter your password to approve refund'
          : 'Why are you declining this?'
      }
      childrenClassName="md:!max-w-[420px]"
    >
      <form onSubmit={handleSubmit} className="flex flex-col gap-6">
        {actionType === 'approve' ? (
          <TextInput
            type="password"
            name="password"
            placeholder="Password"
            value={values.password}
            onBlur={handleBlur}
            onChange={handleChange}
            errors={errors.password && touched.password ? errors.password : ''}
            hasIcon={false}
          />
        ) : (
          <TextInput
            type="text"
            name="reason"
            placeholder="Decline reason"
            value={values.reason}
            onBlur={handleBlur}
            onChange={handleChange}
            errors={errors.reason && touched.reason ? errors.reason : ''}
            hasIcon={false}
          />
        )}

        <Button
          type="submit"
          label={actionType === 'approve' ? 'Approve refund' : 'Decline'}
          primary
          className="!w-full"
          loading={approvingRefund || decliningRefund}
          disabled={approvingRefund || decliningRefund}
        />
      </form>
    </ModalComponent>
  )
}
